import { apiRequest } from '@scc/lib'
import type { PlanDefaultRepository, PlanDefaultPatch } from '@/data/repositories/types'
import type { BriefComputeResult, PlanDefaultRow } from '@/modules/launch/templating-types'

const base = (agencyId: number) => `/agencies/${agencyId}/plan-defaults`

export function createApiPlanDefaultRepository(): PlanDefaultRepository {
  return {
    list: (agencyId) => apiRequest<PlanDefaultRow[]>(base(agencyId)),

    // Resolve + compute in one round trip: the builder needs config, provenance
    // and outputs together, and the resolved config is what gets frozen on save.
    compute: (agencyId, brief, overrides) =>
      apiRequest<BriefComputeResult>(`${base(agencyId)}/compute`, {
        method: 'POST',
        body: { brief, ...(overrides ? { overrides } : {}) },
      }),

    upsert: async (agencyId, kind, key, patch: PlanDefaultPatch) => {
      await apiRequest<unknown>(`${base(agencyId)}/${kind}/${key}`, { method: 'PUT', body: patch })
    },

    revert: async (agencyId, kind, key) => {
      await apiRequest<unknown>(`${base(agencyId)}/${kind}/${key}`, { method: 'DELETE' })
    },
  }
}
